import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import { UnclaimedPrize } from 'components/dashboard/your-wins/UnclaimedPrize';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const TIERS = [
  { code: 'DAYMAKERboost', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'DAYMAKER', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Diamond', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Platinum', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Gold', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Silver', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Bronze', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Treat3', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Treat2', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  { code: 'Treat1', prizeType: 'MAIN_DRAW' as const, imageLocation: '' },
  {
    code: 'MONTHLY_GIVEAWAY',
    prizeType: 'MONTHLY_GIVEAWAY' as const,
    imageLocation:
      'https://prize-assets.daymade.co.uk/406f4760-f143-4cc3-96d2-055342850857.jpg',
  },
  {
    code: 'POUND_RAFFLE',
    prizeType: 'TOKEN_TOWN' as const,
    drawName: 'Pound Raffle',
    imageLocation:
      'https://prize-assets.daymade.co.uk/406f4760-f143-4cc3-96d2-055342850857.jpg',
  },
];

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'} withNoPadding>
      <AboutUsSiteContainer>
        <div style={{ marginBottom: 24 }}>
          <h3 className="aboutUsTypographyHeaderLarge">
            Unclaimed Weekly Draw Prize
          </h3>
          <p>
            A card showing an unclaimed win from the weekly draw. Displays the
            prize tier background, tier icon, prize name, win date, and a
            claim/expired button.
          </p>
        </div>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {TIERS.map((tier) => (
              <UnclaimedPrize
                key={tier.code}
                prizeWinId={`demo-${tier.code}`}
                prizeTierCode={tier.code}
                prizeType={tier.prizeType}
                prizeImageLocation={tier.imageLocation}
                createdAt="2026-03-01T00:00:00.000Z"
                expiresAt="2026-12-31T00:00:00.000Z"
                drawName={tier.drawName || ''}
              />
            ))}
            <UnclaimedPrize
              prizeWinId="demo-expired"
              prizeTierCode="Gold"
              prizeType="MAIN_DRAW"
              prizeImageLocation=""
              createdAt="2026-02-14T00:00:00.000Z"
              expiresAt="2025-01-01T00:00:00.000Z"
              drawName={''}
            />
          </div>
        </AboutUsSiteInnerContainer>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Unclaimed Weekly Draw Prize',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
